<template>
  <v-container
        class="fill-height"
        fluid>
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-12">
                <v-toolbar
                    color="primary"
                    dark
                    flat>
                    <v-toolbar-title>Aanmelden</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-alert type="success" dismissible v-if="isSuccess">
                    Uw account is succesvol aangemaakt. Ga naar uw email om het account te bevestigen.
                  </v-alert>
                    <v-form ref="form">
                    <v-text-field
                        v-model.trim="form.email"
                        :rules="emailRules"
                        label="Email"
                        name="email"
                        prepend-icon="mdi-account"
                        :disabled="isLoading"
                        type="email"
                    ></v-text-field>

                    <v-text-field
                        v-model.trim="form.password"
                        :rules="passwordRules"
                        id="password"
                        label="Wachtwoord"
                        name="password"
                        prepend-icon="mdi-lock"
                        :disabled="isLoading"
                        type="password"
                    ></v-text-field>

                    <v-text-field
                        v-model.trim="form.confirmPassword"
                        :rules="confirmPasswordRules"
                        id="confirmPassword"
                        label="Bevestig Wachtwoord"
                        name="confirmPassword"
                        prepend-icon="mdi-lock"
                        :disabled="isLoading"
                        type="password"
                    ></v-text-field>
                    <v-text-field
                      v-model="form.dateOfBirth"
                      type="date"
                      :rules="dateOfBirthRules"
                      prepend-icon="mdi-calendar-outline"
                        :disabled="isLoading"
                      label="Uw Geboortedatum">
                  </v-text-field>
                  <v-switch
                      v-model="form.cloudStorage"
                      prepend-icon="mdi-cloud-outline"
                      :disabled="isLoading"
                      label="Cloud opslag toestaan">
                  </v-switch>
                  <v-switch 
                      v-model="form.sex" 
                      :prepend-icon="(form.sex) ? 'mdi-human-male' : 'mdi-human-female'"
                      :disabled="isLoading"
                      :label="form.sex ? 'Man' : 'Vrouw'">
                  </v-switch>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    
                    <v-btn color="primary" 
                      @click="validate"
                      :disabled="isLoading"><loader class="mr-2" width="1rem" v-if="isLoading"></loader>Aanmelden</v-btn>
                </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
import Loader from '@/components/Loader';
const capitals = /^(?=.*[a-z])(?=.*[A-Z])/
const numbers = /^(?=.*[0-9])/
const special = /^(?=.*[?!@#\$%\^&\*])/
const length = /^(?=.{8,})/
const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  export default {
    components: {
      Loader
    },
    data() {
      return {
        isLoading: false,
        isSuccess: false,
        form: {
          sex: false,
          dateOfBirth: null,
          email: null,
          password: null,
          cloudStorage: true,
          firebasePushToken: localStorage.getItem('pushToken'),
          confirmPassword: null,
        },
        dateOfBirthRules: [
          v => !!v || 'Geboortedatum is verplicht.'
        ],
        emailRules: [
          v => !!v || 'Email is verplicht',
          v => email.test(v) || 'Geen geldige email.'
          //v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        passwordRules: [
          v => capitals.test(v) || "Wachtwoord moet hoofd- en kleine letters bevatten.",
          v => numbers.test(v) || "Wachtwoord moet een nummer bevatten.",
          v => special.test(v) || "Wachtwoord minimaal een !, ?, @, #, % of * bevatten.",
          v => length.test(v) || "Wachtwoord moet minimaal 8 karakters zijn."
        ],
        confirmPasswordRules: [
          v => v === this.form.password || "Wachtwoorden komen niet overeen."
        ]
      }
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.isLoading = true;
          let form = Object.assign({}, this.form);
          form.sex = (form.sex) ? "m" : "v"
          this.$http.post('api/Auth/Register', form).then((res) => {
            this.isSuccess = true;
          }).finally(() => {
            this.isLoading = false;
          });
        }
      }
    }
  }
</script>